var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",class:_vm.id,on:{"click":function($event){$event.preventDefault();return _vm.$emit('clicked')}}},[_c('use',{attrs:{"xlink:href":`#${_vm.id}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }